import React, {useEffect} from "react"

export default () => {
    useEffect(() => {
        window.location.href = 'https://getthebox.eu';
    }, []);

    return (
        <div>
            Trwa przekierowanie na stronę główną...
        </div>
    )
}
